import { Fragment } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogDescription,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { PhoneIcon, PhoneIncomingIcon, XIcon } from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";

const initialTimestamp = Math.floor(Date.now() / 1000);

export default function CallModal({
  show = false,
  callId = null,
  title = "Incoming Call",
  body = "You have an incoming call",
  timestamp = initialTimestamp,
  onClose = () => {},
}) {
  const navigate = useNavigate();

  return (
    <Transition show={show}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={() => {}}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            />
          </TransitionChild>
          {/* Headless UI marks the backdrop aria-hidden, so the content cannot
              live inside it. This box is the one the backdrop used to give it. */}
          <div className="fixed inset-0">
            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
                <div>
                  <PhoneIncomingIcon
                    className="mx-auto h-8 w-8 text-green-600"
                    aria-hidden="true"
                  />
                  <div className="mt-3 text-center sm:mt-5">
                    <DialogTitle
                      as="h3"
                      className="text-lg leading-6 font-medium text-gray-900"
                    >
                      {title}
                    </DialogTitle>
                    <div className="mt-1">
                      <DialogDescription
                        as="p"
                        className="text-sm text-gray-500"
                      >
                        {body}
                      </DialogDescription>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6 flex items-center space-x-2">
                  <div className="flex-1 flex items-center justify-center space-x-2">
                    <button
                      onClick={onClose}
                      className="mx-auto flex items-center justify-center h-12 w-12 p-2 rounded-full bg-red-500 focus:outline-none focus-visible:ring-0"
                    >
                      <XIcon className="h-6 w-6 text-white" />
                    </button>
                  </div>
                  <div className="flex-1 flex items-center justify-center space-x-2">
                    <button
                      onClick={() => {
                        navigate(
                          `/consultation/${callId}?video=true&call=true&time=${timestamp}&confirm=true`,
                        );
                        onClose();
                      }}
                      className="mx-auto flex items-center justify-center h-12 w-12 p-2 rounded-full bg-green-500 focus:outline-none focus-visible:ring-0"
                    >
                      <PhoneIcon className="h-6 w-6 text-white" />
                    </button>
                  </div>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
